// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FnyP","title":"styles_title__283GV"};